import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useTranslations } from "next-intl";
import { UiLegacy } from "@silvertours/front-legacy-shared";
import { analytics } from "@silvertours/front-entities";
import { Theme, Ui } from "@silvertours/front-shared";
import { useMedia } from "react-use";
import { CheckboxContainer, OptionsSection, OptionsWrapper, StyledLabel, StyledButton } from "./SearchFormOptions.styles";
import { CAR_CATEGORY_OPTIONS, EXTRA_OPTIONS } from "./const";
var OptionsContainer = function(param) {
    var buttonText = param.buttonText, children = param.children, isMobile = param.isMobile, onClose = param.onClose, title = param.title;
    return /*#__PURE__*/ _jsx(OptionsWrapper, {
        isMobile: isMobile,
        children: isMobile ? /*#__PURE__*/ _jsxs(Ui.Overlay, {
            open: true,
            title: title,
            onClose: onClose,
            children: [
                children,
                /*#__PURE__*/ _jsx(StyledButton, {
                    fullWidth: true,
                    onClick: onClose,
                    children: buttonText
                })
            ]
        }) : /*#__PURE__*/ _jsx("aside", {
            children: children
        })
    });
};
var SearchFormOptions = function(param) {
    var checked = param.checked, onChange = param.onChange, setShowOptions = param.setShowOptions;
    var t = useTranslations("features.stageLegacy.stage.searchForm");
    var isMobile = useMedia("(max-width: ".concat(Theme.getBreakpoint("lg"), "px)"), false);
    var handleChange = function(event) {
        analytics.gtm.trackOptionsChange(event.target.id);
        onChange === null || onChange === void 0 ? void 0 : onChange(event.target.id);
    };
    return /*#__PURE__*/ _jsxs(OptionsContainer, {
        buttonText: t("options.modalButton"),
        onClose: function() {
            setShowOptions(false);
        },
        isMobile: isMobile,
        title: t("options.modalTitle"),
        children: [
            /*#__PURE__*/ _jsxs(OptionsSection, {
                children: [
                    /*#__PURE__*/ _jsx(StyledLabel, {
                        children: t("options.headline.insurance")
                    }),
                    /*#__PURE__*/ _jsx(UiLegacy.Checkbox, {
                        label: t("options.checkbox.insurance"),
                        id: "insfull",
                        name: "insurance_coverage",
                        value: "full",
                        onChange: handleChange
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(OptionsSection, {
                children: [
                    /*#__PURE__*/ _jsx(StyledLabel, {
                        children: t("options.headline.vehicleClass")
                    }),
                    /*#__PURE__*/ _jsx(CheckboxContainer, {
                        children: CAR_CATEGORY_OPTIONS.map(function(param) {
                            var id = param.id, key = param.key, value = param.value;
                            var label = t("options.checkbox.".concat(key));
                            if (!label) {
                                /* Translation file contains the logic for which options to render per locale */ return null;
                            }
                            return /*#__PURE__*/ _jsx(UiLegacy.Checkbox, {
                                checked: checked.includes(value),
                                label: label,
                                id: id,
                                name: "acrissDescriptions[]",
                                value: value,
                                onChange: handleChange
                            }, id);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(OptionsSection, {
                children: [
                    /*#__PURE__*/ _jsx(StyledLabel, {
                        children: t("options.headline.inclusive")
                    }),
                    /*#__PURE__*/ _jsx(CheckboxContainer, {
                        children: EXTRA_OPTIONS.map(function(param) {
                            var id = param.id, key = param.key, name = param.name, value = param.value;
                            var label = t("options.checkbox.".concat(key));
                            if (!label) {
                                return null;
                            }
                            return /*#__PURE__*/ _jsx(UiLegacy.Checkbox, {
                                checked: checked.includes(value),
                                label: label,
                                id: id,
                                name: name,
                                value: value,
                                onChange: handleChange
                            }, id);
                        })
                    })
                ]
            })
        ]
    });
};
export { SearchFormOptions };
